import { isDefined } from "@clipboard-health/util-ts";
import { useLocalStorage } from "@src/appV2/lib/utils";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import {
  REFERRAL_CODE_QUERY_PARAM_KEY,
  REFERRAL_REDEEM_CODE_STORAGE_KEY,
  REFERRAL_REDEMPTION_STORAGE_KEY,
} from "./constants";
import { REFERRAL_REDEEM_CODE_FULL_PATH } from "./paths";
import { type ReferralRedemption } from "./types";

interface RedirectToReferralPage {
  pathname: string;
  search: Record<string, string>;
}

export function useRedeemReferralNavigation() {
  const location = useLocation();

  // This one is deprecated in favor of REFERRAL_REDEMPTION_STORAGE_KEY, there were earlier versions of the app that used this
  const [storedReferralCode, , removeStoredReferralCode] = useLocalStorage(
    REFERRAL_REDEEM_CODE_STORAGE_KEY,
    ""
  );

  const [referralRedemption, , removeReferralRedemption] = useLocalStorage<
    ReferralRedemption | undefined
  >(REFERRAL_REDEMPTION_STORAGE_KEY, undefined);

  const [redirectToReferralPage, setRedirectToReferralPage] = useState<
    RedirectToReferralPage | undefined
  >(undefined);

  // We redirect if there is a referral code, and we are not
  // already on the redeem referral page.
  // This makes it imperative that we clear the referral code when we leave the
  // referral code page.
  useEffect(() => {
    const referralCode = referralRedemption?.code ?? storedReferralCode;
    const shouldRedirect =
      isDefined(referralCode) &&
      referralCode.length > 0 &&
      location.pathname !== REFERRAL_REDEEM_CODE_FULL_PATH;

    if (shouldRedirect) {
      setRedirectToReferralPage({
        pathname: REFERRAL_REDEEM_CODE_FULL_PATH,
        search: { [REFERRAL_CODE_QUERY_PARAM_KEY]: referralCode },
      });
    } else {
      setRedirectToReferralPage(undefined);
    }
  }, [referralRedemption, storedReferralCode, location.pathname]);

  const clearReferralRedemption = () => {
    // This one is deprecated, there were earlier versions of the app that used this
    removeStoredReferralCode();

    removeReferralRedemption();
  };

  return {
    clearReferralRedemption,
    redirectToReferralPage,
  };
}
